module.exports = __webpack_public_path__ + "res/img_bg.801dff7158ecca755455da92224ad26f.png";